import { FC, SVGProps } from 'react';

export const PersonIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
		<path
			d="M6.76562 11.5059L4.9375 12.9707C3.71375 13.9497 3 15.4328 3 17V19.4141C4.63758 21.1806 8.23584 22 12 22C15.7642 22 19.3624 21.1806 21 19.4141V17C21 15.4328 20.2862 13.9497 19.0625 12.9707L17.2344 11.5059L15.9844 13.0684L17.8145 14.5312C18.5649 15.1316 19 16.0389 19 17V18.4551C18.2236 19.1512 15.682 20 12 20C8.31804 20 5.77642 19.1512 5 18.4551V17C5 16.0389 5.43507 15.1316 6.18555 14.5312L8.01562 13.0684L6.76562 11.5059ZM12 2C9.25042 2 7 4.25042 7 7C7 9.74958 9.25042 12 12 12C14.7496 12 17 9.74958 17 7C17 4.25042 14.7496 2 12 2ZM12 4C13.6687 4 15 5.3313 15 7C15 8.6687 13.6687 10 12 10C10.3313 10 9 8.6687 9 7C9 5.3313 10.3313 4 12 4Z"
			fill="currentColor"
		/>
	</svg>
);
